module.exports = __webpack_public_path__ + "img/text.360892bb.svg";